import { asyncAction, action } from '../../utils/actions';

// async actions
export const sendResetPasswordLink = asyncAction('auth/SEND_RESET_PASSWORD_LINK');
export const signUp = asyncAction('auth/SIGN_UP');
export const changePassword = asyncAction('auth/CHANGE_PASSWORD');
export const updateProfile = asyncAction('auth/UPDATE_PROFILE');
export const confirmEmail = asyncAction('auth/CONFIRM_EMAIL');
export const signIn = asyncAction('auth/SIGN_IN');

// sync actions
export const setResetPasswordToken = action('auth/SET_RESET_PASSWORD_TOKEN');
export const setIsAuthorized = action('auth/SET_IS_AUTHORIZED');
export const removeUserData = action('auth/REMOVE_USER_DATA');
export const setUserDataRemoved = action('auth/SET_USER_DATA_REMOVED');
export const changeAuthInfo = action('auth/CHANGE_AUTH_INFO');
export const setUserData = action('auth/SET_USER_DATA');
export const setAPIInProgress = action('auth/SET_API_IN_PROGRESS');
